import { render, staticRenderFns } from "./JoinChallengeWithTeam.vue?vue&type=template&id=65135ab1&lang=pug&"
import script from "./JoinChallengeWithTeam.vue?vue&type=script&lang=js&"
export * from "./JoinChallengeWithTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports